<!--任务管理-->
<template>
  <div class="edit-area">
    <el-form ref="registerRef"  :model="detailParam" :rules="rules" label-width="140px">
      <el-form-item  label="活动名:"  prop="activityName">
        <el-input style="width: 300px" v-model="detailParam.activityName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item  label="消耗课时:" prop="classHours" >
        <el-input-number :precision="1" :step="0.5" :max="999" :min="0" v-model="detailParam.classHours" placeholder="" style="width: 300px;" ></el-input-number >
      </el-form-item>

      <el-form-item  label="提成计算方式:" prop="classFlag" >
        <el-radio-group v-model="detailParam.classFlag">
          <el-radio :label='1'>课时计算</el-radio>
          <el-radio :label='2'>金额计算</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item  label="人数限制:" prop="numberLimit" >
        <el-input style="width: 300px" v-model="detailParam.numberLimit"></el-input>
      </el-form-item>
      <el-form-item  label="开始时间:" prop="startDate" >
          <el-date-picker
                  v-model="detailParam.startDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item  label="结束时间:" prop="endDate" >
          <el-date-picker
                  v-model="detailParam.endDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item  label="老师1:" prop="teacher1" >
        <el-select v-model="detailParam.teacher1" placeholder="指定的老师" clearable style="width: 300px;">
          <el-option v-for="item in allWorker"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item  label="老师2:" >
        <el-select v-model="detailParam.teacher2" placeholder="指定的老师" clearable style="width: 300px;">
          <el-option v-for="item in allWorker"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item  label="老师3:" >
        <el-select v-model="detailParam.teacher3" placeholder="指定的老师" clearable style="width: 300px;">
          <el-option v-for="item in allWorker"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item  label="老师4:" >
        <el-select v-model="detailParam.teacher4" placeholder="指定的老师" clearable style="width: 300px;">
          <el-option v-for="item in allWorker"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item  label="活动详情:" >
        <el-input
          type="textarea"
          placeholder=""
          v-model="detailParam.activityDetail"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button  @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleOK('registerRef')">确认</el-button>
    </div>
  </div>
</template>
<style>

</style>

<script>
  import globaldata from "../../../../utils/globaldata";
  export default {
    name: 'storeLevelActivityDetail',
    props: {
      title: {
        msg: ''
      },
      detailParam :{
        id:'',
        storeFrontId:'',
        activityName:'',
        classHours :''  ,
        classAmount : '' ,
        startDate : '' ,
        endDate : '' ,
        activityDetail : '',
        numberLimit:'',
        teacher1:'',
        teacher2:'',
        teacher3:'',
        teacher4:'',
        classFlag:1,
      },
    },
    data() {
      return {
        //发送短信
        timerSendCodeTip :'发送短信',
        rules:{
          activityName:[{required:true,message:"请输入活动名",trigger:"blur"}],
          classHours:[{required:true,message:"请输入消耗课时",trigger:"blur"}],
          classFlag:[{required:true,message:"请选择提成计算方式",trigger:"blur"}],
          numberLimit:[{required:true,message:"请输入活动人数限制",trigger:"blur"}],
          startDate:[{required:true,message:"开始时间不能为空",trigger:"blur"}],
          endDate:[{required:true,message:"结束时间不能为空",trigger:"blur"}],
          // teacher1:[{required:true,message:"起码指定一个老师",trigger:"blur"}],
        },
        allWorker:[

        ],
      }
    },
    created(){
      globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    },
    mounted() {

    },
    methods: {
      handleOK(registerRef){
        this.$refs[registerRef].validate((valid) => {
          if (valid) {
            this.onCreateStoreLevelActivity();
          } else {
            return false
          }
        });
      },
      handleCancel(){
        this.$emit('onBtnCancel');
      },
      //创建任务设置
      onCreateStoreLevelActivity(){
        console.log("onCreateStoreLevelActivity111")
        this.$emit('onStoreLevelActivity',this.detailParam);

      },

      doUpdatePosition(t,dlg){

      },
      //打开修改弹出框
      handleUpdateOneDlg(row){
        this.visibleDlgUpdate = true;
        let month = [row.startMonth,row.endMonth]
        this.updateParam = {
          id:row.id,
          lessonName:row.lessonName,
          levelName:row.levelName,
          maxLevelName:row.maxLevelName,
          levelVal:row.levelVal,
          maxLevelVal:row.maxLevelVal,
          month:month,
          type:row.type,
          consumeNum:row.consumeNum,
        }
      },
      getStoreWorkersInfo(list){
        console.info(list)
        this.allWorker.push({id:null,name:"无"})
        this.allWorker =this.allWorker.concat(list) ;
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/activity-setting/components/storeLevelActivityDetail.vue